import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component, ContentChild, Input
} from "@angular/core";

import {map, startWith, takeUntil} from "rxjs/operators";
import {
  IntMultiTagFilterSelectControlComponent
} from "./int-multi-tag-filter-select-control.component";
import {IntMultiTagSelectComponent} from "../int-multi-tag-select";
import {DestroyStreamService} from "../../../services";
import {IFSelectDataPayload} from "../../../types";
import {combineLatest} from "rxjs";

const defaultPredicate = (search: string, list: Array<IFSelectDataPayload>): Array<IFSelectDataPayload> => {
  return list.filter(({label}) => {
    const _label = (label || '').toLowerCase();
    const _search = (search || '').toLowerCase();
    return _label.includes(_search);
  });
}

@Component({
  selector: 'int-multi-tag-filter-select',
  template: `
    <ng-content></ng-content>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    DestroyStreamService
  ]
})
export class IntMultiTagFilterSelectComponent implements AfterContentInit {

  @Input() predicateFn: (search: string, list: Array<IFSelectDataPayload>) => Array<IFSelectDataPayload>
  = defaultPredicate;

  @ContentChild(IntMultiTagFilterSelectControlComponent) private readonly filter!: IntMultiTagFilterSelectControlComponent;
  @ContentChild(IntMultiTagSelectComponent) private readonly multiTag!: IntMultiTagSelectComponent;

  constructor(
    private readonly destroy$: DestroyStreamService
  ) {
  }

  ngAfterContentInit() {
    if(!this.filter || !this.multiTag) {
      return;
    }

    combineLatest([
      this.multiTag.fullList$.pipe(takeUntil(this.destroy$)),
      this.filter.change$.pipe(startWith(''), takeUntil(this.destroy$))
    ])
      .pipe(
        map(([list, search]) => {
          return this.predicateFn(search, list);
        }),
        takeUntil(this.destroy$)
      )
      .subscribe((values) => {
        this.multiTag.list$.next(values);
      });

    this.multiTag.open$
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe((status) => {
      if(!status) {
        this.filter.formControl.patchValue('');
      }
    });

    this.multiTag.dropDownPaddings = '0 1rem 1rem';
  }
}
